const { flex } = window;
const {
  React,
  ReactAddons: { PropTypes },
} = flex.lib;

class OrgUserLanguageSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supportedLanguages: [],
      userSelectedLanguage: null,
    };
  }

  isAuthenticated = !!flex.getStore().orgUser;
  selectedLanguageKey = "selectedLanguage";

  async componentDidMount() {
    const [{ supportedLangs, defaultLang }, selectedLang] = await Promise.all([
      this.getOrgSupportedLangs(),
      this.getOrgUserSelectedLanguage()
    ]);

    this.setState({ supportedLanguages: supportedLangs }, async () => {
      if (supportedLangs?.some((l) => l.languageCode === selectedLang)) {
        await this.handleLanguageChange(selectedLang)
      } else {
        let selectedItem = defaultLang.languageCode;
        const selectedLangLocalStorage = localStorage.getItem(this.selectedLanguageKey);

        if (selectedLangLocalStorage) {
          selectedItem = JSON.parse(selectedLangLocalStorage)?.selectedLanguage;
        }

        await this.handleLanguageChange(selectedItem)
      }
    })
  }


  //const { FlexApiRequest } = window;

  // function request(path, params) {
  //   return FlexApiRequest.POST({ path }).send(params);
  // }
  fetchData(path, requestData) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: flex.getApiUrl(path),
        async: true,
        type: "post",
        headers: flex.getHeaders(),
        contentType: "application/json",
        data: JSON.stringify(requestData),
        success: function (data) {
          resolve(data);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          flex.handleAjaxError(jqXHR, textStatus, errorThrown);
          reject(errorThrown);
        },
      });
    });
  }

  async getOrgSupportedLangs() {
    const path = "/api/v1/org/getsupportedlangsbyorgid";
    const orgId = flex.getStore().appContext?.app?.orgId;
    const requestData = { orgId };

    try {
      return await this.fetchData(path, requestData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async getOrgUserSelectedLanguage() {
    if (!this.isAuthenticated) {
      return null;
    }

    try {
      const result = await this.fetchData('/api/v1/org/getorguserselectedlanguage', {});
      return result.selectedLanguage;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }

  async saveOrgUserSelectedLanguage(selectedLanguage) {
    try {
      await this.fetchData('/api/v1/org/saveorguserselectedlanguage', { selectedLanguage });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async handleLanguageChange(selectedLanguage) {
    if (this.props?.onChange) {
      this.props.onChange(selectedLanguage);
    }

    if (this.isAuthenticated && this.props.saveOnChange) {
      await this.saveOrgUserSelectedLanguage(selectedLanguage);
    }

    this.setState({ userSelectedLanguage: selectedLanguage });
    this.setSelectedLanguageToLocalStorage(selectedLanguage);
  }

  setSelectedLanguageToLocalStorage(value) {
    const storageValue = {
      selectedLanguage: value,
      selectedLanguageUpdatedAt: Date.now(),
    };
    localStorage.setItem(this.selectedLanguageKey, JSON.stringify(storageValue));
    flex.setCookie({ key: "selectedlang", value })
  }

  render() {
    const { supportedLanguages, userSelectedLanguage } = this.state;

    const selectorClassName = this.isAuthenticated
      ? "form-control"
      : "displayLanguage ml-2 mr-3";

    const languageSelector = (
      <select
        className={selectorClassName}
        id={this.selectedLanguageKey}
        name={this.selectedLanguageKey}
        value={userSelectedLanguage}
        onChange={(e) => {
          this.handleLanguageChange(e?.target.value);
        }}
        required
      >
        {supportedLanguages.map((lang) => (
          <option
            key={lang?.languageCode}
            label={lang?.nativeName}
            value={lang?.languageCode}
          ></option>
        ))}
      </select>
    );

    return this.isAuthenticated ? (
      <div>
        <h2>{flex.text('UX_HOME_ACCOUNT_SETTINGS_LANGUAGE_PREFERENCE', 'Language Preference')}</h2>
        <div className="row">
          <div className="form-group select col-sm-6">
            <div className="form-group">
              <label
                className="control-label"
                data-required="true"
                htmlFor={this.selectedLanguageKey}
              >
                {flex.text('UX_HOME_ACCOUNT_SETTINGS_LANGUAGE_PREFERENCE', 'Language Preference')}<span className="required-symbol"> *</span>
              </label>
              {languageSelector}
            </div>
          </div>
        </div>
      </div>
    ) : supportedLanguages.length > 1 ? (
      <div>
        <label htmlFor={this.selectedLanguageKey}>
          {flex.text('UX_HOME_ACCOUNT_SETTINGS_LANGUAGE_PREFERENCE', 'Language Preference')}:
          {languageSelector}
        </label>
      </div>
    ) : (
      ""
    );
  }
}

OrgUserLanguageSelector.propTypes = {
  saveOnChange: PropTypes.bool,
};

OrgUserLanguageSelector.defaultProps = {
  saveOnChange: false,
};
module.exports = OrgUserLanguageSelector;
